import React from 'react';
import { AutoSizer, List as VirtuList } from 'react-virtualized';

interface IItem {
  label: string;
  value: number;
}

interface IVirtualizedList {
  listItems: IItem[] | undefined;
  itemEl: React.ElementType;
  itemIsSelected?: boolean;
  rowHeight?: number;
}

const VirtualizedList = ({
  listItems,
  itemIsSelected,
  itemEl: ItemEl,
  rowHeight,
}: IVirtualizedList) => (
  // @ts-ignore
  <AutoSizer>
    {({ height, width }) => (
      // @ts-ignore
      <VirtuList
        height={height}
        width={width}
        style={{ paddingBottom: 16 }}
        rowCount={listItems ? listItems.length : 1}
        rowHeight={rowHeight ?? 40}
        rowRenderer={({ key, index, style }) => {
          return (
            listItems?.[index] && (
              <div key={key} style={style} className="virtual-list-item">
                <ItemEl isSelected={itemIsSelected} {...listItems[index]} />
              </div>
            )
          );
        }}
      />
    )}
  </AutoSizer>
);

export default VirtualizedList;
